import React from "react";

import { SliderContextProvider } from "../context/Slider.context";
import {
  ManProfileSlider,
  ManProfileSliderPropTypes,
} from "./ManProfileSlider";

type PropTypes = ManProfileSliderPropTypes & {
  initialIndex: number;
};

export const ManProfileSliderModal: React.FC<PropTypes> = ({
  initialIndex,
  data,
}) => {
  return (
    <SliderContextProvider
      initialIndex={initialIndex}
      mediaLength={data.length}
    >
      <ManProfileSlider data={data} />
    </SliderContextProvider>
  );
};
